import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';

type Info = {
    id: number;
    date: string;
    title: string;
    article: string;
    note: string;
    flag: number;
};

type ThreadProps = {
    information: Info[];
    articleLength: number;
};

const Thread: React.FC<ThreadProps> = ({information, articleLength}) => {

    return (
        <React.Fragment>
            {information.slice(0, articleLength).map((value, index) => (
                <Card bg="light" text="dark" className="mx-2 opacity-75 mb-2 thread_card border-0" key={index}>
                    <Card.Header className='bg-light'><div className='row d-flex align-items-center'>
                        <div className="col-8">{value.title}</div>
                        <div className="col date">{value.date}</div>
                        </div></Card.Header>
                    <Card.Body>
                        <blockquote className="blockquote mb-0">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                Integer posuere erat a ante.
                            </p>
                            <footer className="blockquote-footer">
                                Someone famous in <cite title="Source Title">Source Title</cite>
                            </footer>
                        </blockquote>
                    </Card.Body>
                </Card>
            ))}
        </React.Fragment>
    );
};

export default Thread;
